var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoMenu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 1312",
    transform: "translate(-738 -220)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "\\uD0C0\\uC6D0 13",
    cx: 28.5,
    cy: 28.5,
    r: 28.5,
    transform: "translate(738 220)",
    style: {
      fill: "#edf6ee"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 133"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uC0AC\\uAC01\\uD615 13",
    style: {
      fill: "none"
    },
    d: "M0 0h30v30H0z",
    transform: "translate(752 234)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "\\uADF8\\uB8F9 6"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 5",
    d: "M248.893 18.683h4.528a1.359 1.359 0 0 0 0-2.718h-4.528a1.359 1.359 0 1 0 0 2.718",
    transform: "translate(511.373 226.714)",
    style: {
      fill: "#00402e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 6",
    d: "M248.893 26.533a1.359 1.359 0 1 0 0 2.718h7.246a1.359 1.359 0 1 0 0-2.718z",
    transform: "translate(511.373 221.89)",
    style: {
      fill: "#00402e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 7",
    d: "M252.6 28.173h-8.948a4.081 4.081 0 0 1-4.077-4.077V5.771H250a1.359 1.359 0 1 0 0-2.718h-11.785a1.359 1.359 0 0 0-1.359 1.359V24.1a6.8 6.8 0 0 0 6.795 6.795h8.949a1.359 1.359 0 1 0 0-2.718",
    transform: "translate(516.247 232.607)",
    style: {
      fill: "#00402e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD328\\uC2A4 8",
    d: "M273.812.472a5.127 5.127 0 0 0-5.121 5.121v3.768a5.126 5.126 0 0 0 3.762 4.932v14a1.359 1.359 0 1 0 2.718 0v-14a5.127 5.127 0 0 0 3.763-4.933V5.593a5.128 5.128 0 0 0-5.122-5.121m2.4 8.889a2.4 2.4 0 1 1-4.807 0V5.593a2.4 2.4 0 0 1 4.807 0z",
    transform: "translate(501.717 233.785)",
    style: {
      fill: "#00a61c"
    }
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMenu);
export default __webpack_public_path__ + "static/media/ico-menu.c3341cde3ef0d728b3def71d942e746b.svg";
export { ForwardRef as ReactComponent };